export enum COMMISSION_SOURCE {
  'SALES_VIEWPOINT' = 0,
  'ONLINE_STORE' = 1
};
